import React from 'react';
import { Pup } from '../types/breed';
import PupCard from './PupCard';

interface FeaturedPupCardProps {
  pup: Pup;
}

const FeaturedPupCard: React.FC<FeaturedPupCardProps> = ({ pup }) => {
  return (
    <div className="featured-pup-wrapper">
      <div className="featured-badge">Pup of the Day</div>
      <PupCard pup={pup} />
    </div>
  );
};

export default FeaturedPupCard;
